import React, { useEffect, useRef, useState } from 'react'
import { copyToClipboard, t } from 'shared'

export const ClipboardButton = ({ label, value }: { label?: string; value: string }) => {
  const [done, setDone] = useState(false)
  const valueRef = useRef(value)
  useEffect(() => {
    if (valueRef.current !== value) {
      setDone(false)
    }
  }, [value])
  if (!hasBrowserSupport) return null

  return (
    <button
      role="button"
      type="button"
      className="ui primary button"
      onClick={() => copyToClipboard(value) && setDone(true)}
    >
      {done ? t('misc.copied') : label ?? t('misc.copy_link')}
    </button>
  )
}

const hasBrowserSupport = () => document.queryCommandSupported && document.queryCommandSupported('copy')
